import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
  tag: 'vds-thumbnail-list-item',
  styleUrl: 'vds-thumbnail-list-item.scss',
  shadow: true,
})
export class VdsThumbnailListItem {

  @Element() el: HTMLVdsThumbnailListItemElement;

  /**
   * Item Headline
   */
  @Prop() headline: string;

  /**
   * Item Subline above headline
   */
  @Prop() label: string;

  /**
   * Item body text
   */
  @Prop() copy: string;

  /**
   * Item link href
   */
  @Prop() href: string;

  /**
   * Item link target
   */
  @Prop() target: string;

  /**
   * The day (format: dd.) displayed in the calender page.
   */
  @Prop() day: string;

  /**
   * The month (format: MMM.) displayed in the calender page.
   */
  @Prop() month: string;

  /**
   * The year (format: yyyy) displayed in the calender page.
   */
  @Prop() year: string;

  render() {
    const { headline, label, copy, href, target, day, month, year } = this;

    return (
      <Host>
        <a href={href} target={target} onMouseEnter={() => this.toggleReadMore()} onMouseLeave={() => this.toggleReadMore()}>
         <div class="grid grid-cols-12 gap-[20px] border-solid border-grey-lighter px-[30px] md:px-[50px] py-[15px] md:py-[25px] border-[2px] hover:shadow-[0_14px_25px_rgba(0,0,0,0.16)]">
            <div class="relative col-span-full sm:col-span-4 md:col-span-3 rounded-[5px]">
              <slot name="image"></slot>

              { day && month && year && this.renderCalendarPage(day, month, year) }

            </div>
            <div class="col-span-full sm:col-span-8 md:col-span-9 mt-[30px] sm:mt-0">
              <div class="text-[14px] text-grey-light leading-[1] uppercase mb-[10px]">{label}</div>
              <h5 class="text-h5 text-grey font-heavy uppercase mb-[10px]">{headline}</h5>
              <p class="mt-0">{copy}</p>

              <div class="grid grid-cols-12">
                <div class="col-span-full flex flex-col-reverse md:flex-row md:justify-between">
                  <div class="flex flex-col gap-[15px] mt-[30px] tablet-portrait:flex-row">
                    <slot name="links-left"></slot>
                  </div>
                  <div class="flex flex-col gap-[15px] tablet-portrait:flex-row tablet-portrait:mt-[30px]">
                    <slot name="links-right"></slot>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </a>

      </Host>
    );
  }

  private renderCalendarPage(day: string, month: string, year: string): string {
    return(
      <div class="absolute -bottom-[30px] right-[9px] grid grid-cols-1 grid-rows-2 h-[60px] w-auto sm:-top-0 sm:bottom-auto sm:right-auto">
        <div class="flex justify-center items-center col-span-full row-span-1 w-full bg-white text-grey text-[11px] font-heavy rounded-t-[4px] px-[5px]">
          <span class="uppercase">{day} {month}</span>
        </div>
        <div class="flex justify-center items-center col-span-full row-span-1 w-full bg-grey text-white text-[11px] font-heavy rounded-b-[4px] px-[5px]">
          <span class="uppercase">{year}</span>
        </div>
      </div>
    );
  }

  private toggleReadMore(): void {
    const readMoreElements = this.el.querySelectorAll('vds-read-more');
    readMoreElements.forEach(element => {
      const link = element.shadowRoot.querySelector('a');
      link.toggleAttribute('aria-hovered');
    });
  }

}
